var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { customEvent, EventError, EventType } from '@assets/utils/customEvent';
import useLocalStorage from '@embed/hooks/useLocalStorage';
import { useApi } from './useApi';
export var PublisherClientIdentificator;
(function (PublisherClientIdentificator) {
    PublisherClientIdentificator["APP_ID"] = "app_id";
    PublisherClientIdentificator["PUBLISHER_CLIENT_ID"] = "publisher_client_id";
})(PublisherClientIdentificator || (PublisherClientIdentificator = {}));
const getPublisherClientFromStorage = (fromStorage) => {
    if (!fromStorage || !fromStorage.expire || !fromStorage.publisherClient) {
        return null;
    }
    const now = new Date();
    const TOO_OLD = 12 * 60 * 60 * 1000;
    if (now.getTime() > fromStorage.expire + TOO_OLD) {
        return null;
    }
    return fromStorage.publisherClient;
};
export const usePublisherClient = (identificator, id, target) => {
    const api = useApi();
    const [publisherClientStorage, setPublisherClientToStorage] = useLocalStorage(`fwn_publisher_client_${id}`, null);
    const [publisherClient, setPublisherClient] = useState(getPublisherClientFromStorage(publisherClientStorage));
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const now = new Date();
            const isExpired = (publisherClientStorage === null || publisherClientStorage === void 0 ? void 0 : publisherClientStorage.expire) &&
                now.getTime() > (publisherClientStorage === null || publisherClientStorage === void 0 ? void 0 : publisherClientStorage.expire);
            if ((!publisherClient || isExpired) && identificator && id) {
                try {
                    const result = yield api.getPublisherClient(identificator, id);
                    setPublisherClient(result.publisher_client);
                    const ttl = 10 * 60 * 1000; //10min
                    setPublisherClientToStorage({
                        expire: new Date().getTime() + ttl,
                        publisherClient: result.publisher_client,
                    });
                }
                catch (e) {
                    customEvent({
                        target,
                        type: [EventType.FW_ERROR, EventType.FW_EMBEDFEED_ERROR],
                        data: {
                            detail: EventError.API_ERROR,
                        },
                    });
                }
            }
        }))();
    }, [
        api,
        identificator,
        id,
        publisherClient,
        publisherClientStorage === null || publisherClientStorage === void 0 ? void 0 : publisherClientStorage.expire,
        setPublisherClientToStorage,
        setPublisherClient,
        target,
    ]);
    return publisherClient;
};
